import {useCallback, useEffect, useState} from "react";
import '@inovua/reactdatagrid-community/index.css'
import {useFormikContext} from "formik";
import {euroFormat} from "../../../utils/usefullFunctions";
import CustomDataGrid from "../../table/CustomDataGrid";

const columns = [
    {name: 'name', header: 'Naam', minWidth: 300, editable: false},
    {
        name: 'amount', header: 'Aantal', defaultFlex: 1, minWidth: 50, type: 'number',
        onRender: (cellProps, {data}) => {
            if (data.id !== 1) cellProps.style.background = '#f8f8f8'
        }
    },
    {
        name: 'cost', header: 'Kost', defaultFlex: 1, minWidth: 50, type: 'number',
        render: ({value}) => {
            if (value) return euroFormat(value)
        },
        onRender: (cellProps, {data}) => {
            if (data.id === 1) cellProps.style.background = '#f8f8f8'
        }
    },
    {
        name: 'sale', header: 'Verkoop', defaultFlex: 1, minWidth: 50, type: 'number',
        render: ({value}) => {
            if (value) return euroFormat(value)
        },
        onRender: (cellProps, {data}) => {
            if (data.id === 1) cellProps.style.background = '#f8f8f8'
        }
    }
];

// Abonnementen component
const ArticlesTable = () => {
    const {values, setFieldValue} = useFormikContext();
    const {service_form_project_options, service_form_project_hosting, service_form_project_data_articles} = values


    const [dataSource, setDataSource] = useState(service_form_project_data_articles);

    // Update the context values when the data source changes
    useEffect(() => {
        setFieldValue("service_form_project_articles_cost", {
            cloud: {cost: dataSource[0].cost, sale: dataSource[0].sale},
            vpn: {cost: dataSource[1].cost, sale: dataSource[1].sale},
            storing: {cost: dataSource[2].cost, sale: dataSource[2].sale},
            storing24: {cost: dataSource[3].cost, sale: dataSource[3].sale},
        })

        const data = [...dataSource]
        data[0].amount = null
        setFieldValue("service_form_project_data_articles", data)

    }, [dataSource])

    // When the options are altered, update the dataSource
    // TODO prijzen vast stellen in backend
    useEffect(() => {
        const data = [...dataSource]
        // Depending on the selected options certain rows are not visible
        data[0].visible = service_form_project_options[5].value;
        data[1].visible = service_form_project_options[7].value;
        data[2].visible = service_form_project_options[3].value;
        data[3].visible = service_form_project_options[4].value;

        // When an option is disabled set the values to 0
        if (!service_form_project_options[5].value) { // Cloud service
            data[0].cost = 0
            data[0].sale = 0
            setFieldValue("service_form_project_hosting", "")
        }
        if (!service_form_project_options[7].value) { // VPN
            data[1].cost = 0
            data[1].sale = 0
            data[1].amount = 0
            setFieldValue("service_form_project_vpn", 0)
        }
        if (!service_form_project_options[3].value) { // Storingsafhandeling tijdens kantooruren
            data[2].cost = 0
            data[2].sale = 0
        }
        if (service_form_project_options[3].value && !data[2].cost) { // Storingsafhandeling tijdens kantooruren
            data[2].cost = 600
            data[2].sale = 600 / 0.8
        }
        if (!service_form_project_options[4].value) { // Aanvulling storingsafhandeling 24/7
            data[3].cost = 0
            data[3].sale = 0
        }
        if (service_form_project_options[4].value && !data[3].cost) { // Aanvulling storingsafhandeling 24/7
            data[3].cost = 500
            data[3].sale = 500 / 0.8
        }

        setDataSource(data)
    }, [service_form_project_options])

    // When hosting is changed show the appropriate rows and change the values
    useEffect(() => {
        const data = [...dataSource]
        if (service_form_project_hosting === "basis") {

            data[0].cost = 1000
            data[0].sale = 1000 / (1 - 0.2)

        } else if (service_form_project_hosting === "xl") {

            data[0].cost = 1600
            data[0].sale = 1600 / (1 - 0.2)

        } else {
            data[0].cost = null
            data[0].sale = null
        }

        setDataSource(data)
    }, [service_form_project_hosting])

    // When the table is edited update other values
    const onEditComplete = useCallback(({value, columnId, rowId}) => {
        const data = [...dataSource];

        if (columnId === "amount") {
            if (rowId === 1) {
                value = parseInt(value || 0)

                data[rowId][columnId] = value;
                data[rowId]["sale"] = value * 50;
            }
        } else if (columnId === "cost" || columnId === "sale") {

            if (rowId === 1) return null
            value = parseInt(value || 0)
            data[rowId][columnId] = value;

        }

        setDataSource(data);
    }, [dataSource])

    return <CustomDataGrid
                idProperty="id"
                onEditComplete={onEditComplete}
                editable={true}
                columns={columns}
                dataSource={dataSource.filter(r => r.visible === true)}
            />
}


export default ArticlesTable